import React from 'react'
import type { FC } from 'react'

import RASealImg from '../../images/ra-seal.png'

const RASeal: FC = () => (
  <img
    src={RASealImg}
    alt="Prêmio Empresa Reclame Aqui 2023"
    loading="lazy"
    width="100%"
    height="auto"
  />
)

export default RASeal
